export enum IvqEventTypes {
  QUIZ_STARTED = 'QuizStarted',
  QUIZ_SKIPPED = 'QuizSkipped',
  QUIZ_SEEK = 'QuizSeek',
  QUESTION_ANSWERED = 'QuestionAnswered',
  QUIZ_SUBMITTED = 'QuizSubmitted',
  QUIZ_RETAKE = 'QuizRetake',
  QUIZ_QUESTION_CHANGED = 'QuizQuestionChanged'
}
